interface ListIconProps {
  icon:
    | 'check'
    | 'circle'
    | 'white check'
    | 'circle dark'
    | 'circle transparent'
    | 'check color';
}
export const BulletIcons = ({ icon }: ListIconProps) => {
  switch (icon) {
    case 'check':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="18"
            height="18.0002"
            rx="9"
            fill="url(#paint0_linear_571_2423)"
          />
          <path
            d="M13.5332 6.23633L8.01042 11.7591L5.24902 8.99773"
            stroke="white"
            strokeWidth="1.86829"
          />
          <defs>
            <linearGradient
              id="paint0_linear_571_2423"
              x1="-5"
              y1="23.0003"
              x2="21.0253"
              y2="-2.4631"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B1CCCF" />
              <stop offset="1" stopColor="#609399" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 'circle':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="18"
            height="18"
            rx="9"
            fill="url(#paint0_linear_453_17851)"
          />
          <circle cx="9" cy="9" r="4" fill="white" fillOpacity="0.9" />
          <defs>
            <linearGradient
              id="paint0_linear_453_17851"
              x1="3.99955"
              y1="16.9765"
              x2="14.9797"
              y2="0.753442"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B1CCCF" />
              <stop offset="1" stopColor="#609399" />
            </linearGradient>
          </defs>
        </svg>
      );

    case 'white check':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
        >
          <circle cx="10" cy="10.1826" r="10" fill="#F0F8F9" />
          <path
            d="M13.9397 7.46488L8.93966 13.0899L6.43977 10.5898"
            stroke="#03292E"
            strokeWidth="1.875"
            strokeLinecap="square"
          />
        </svg>
      );
    case 'circle dark':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <rect
            width="16"
            height="16"
            rx="8"
            fill="url(#paint0_linear_1245_3782)"
          />
          <circle cx="8" cy="8" r="4" fill="#F0F8F9" />
          <defs>
            <linearGradient
              id="paint0_linear_1245_3782"
              x1="1.07601"
              y1="17.5008"
              x2="18.1389"
              y2="1.16852"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#0F3B40" />
              <stop offset="1" stopColor="#609399" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 'circle transparent':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <rect
            width="16"
            height="16"
            rx="8"
            fill="url(#paint0_linear_1451_3960)"
          />
          <circle cx="8" cy="8" r="4" fill="#F0F8F9" />
          <defs>
            <linearGradient
              id="paint0_linear_1451_3960"
              x1="1.59823"
              y1="18.5124"
              x2="18.5734"
              y2="1.16177"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#81B8BE" />
              <stop offset="1" stopColor="#E0F2F4" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 'check color':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="18"
            height="18.0002"
            rx="9"
            fill="url(#paint0_linear_1040_6326)"
          />
          <path
            d="M13.5332 6.23633L8.01042 11.7591L5.24902 8.99773"
            stroke="white"
            strokeWidth="1.86829"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1040_6326"
              x1="-5"
              y1="23.0003"
              x2="21.0253"
              y2="-2.4631"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B1CCCF" />
              <stop offset="1" stopColor="#609399" />
            </linearGradient>
          </defs>
        </svg>
      );

    default:
      return null;
  }
};
